import app from '../app';

const bodyDiv = document.querySelector('body');
const userId = bodyDiv && bodyDiv.dataset.loggedInUser;

if (userId) {
    app(userId).start();
} else {
    // This should never happen.
    throw new Error('No user id found in body dataset');
}
